import React from 'react'

const SeamlessIntegrationIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 16.933 16.933"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <path
                        fill="#ff9751"
                        d="M2.938 9.654v3.027c0 .09.044.174.12.223l5.265 3.457a.265.265 0 0 0 .289 0l5.265-3.457a.265.265 0 0 0 .12-.223V9.654H2.936z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#ff7f29"
                        d="M8.467 16.404c.05 0 .1-.014.145-.043l5.265-3.457a.265.265 0 0 0 .12-.223V9.654H8.465"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff7f29"
                        d="M9.974.602 1.298 8.024a.22.22 0 0 0 0 .346l5.257 4.498a.321.321 0 0 0 .405 0l8.675-7.422a.22.22 0 0 0 .002-.347L10.379.601a.313.313 0 0 0-.207-.072.311.311 0 0 0-.198.073z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#ff9751"
                        d="M6.555.6 1.298 5.1a.22.22 0 0 0-.002.346l8.678 7.424a.321.321 0 0 0 .405-.002l5.258-4.499a.22.22 0 0 0 0-.345L6.96.6a.312.312 0 0 0-.207-.07.313.313 0 0 0-.198.07z"
                        opacity={1}
                        data-original="#ff9751"
                        className=""
                    />
                    <path
                        fill="#e4eff8"
                        d="M8.467 1.891 2.804 6.736l5.662 4.843 5.663-4.844z"
                        opacity={1}
                        data-original="#e4eff8"
                        className=""
                    />
                    <path
                        fill="#c4dcf0"
                        d="m8.466 11.58 5.663-4.845L8.467 1.89"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#549ad4"
                        d="M14.815 1.32a.265.265 0 0 0-.186.454l.348.348H13.64c-2.694 0-4.91 1.87-4.91 4.228v.529c0 .353.53.353.53 0v-.53c0-2.022 1.944-3.698 4.38-3.698h1.326l-.338.338c-.27.25.126.644.375.373l.793-.793a.265.265 0 0 0 0-.376l-.793-.792a.264.264 0 0 0-.19-.08z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                    <path
                        fill="#c4dcf0"
                        d="m6.62 3.471-.406.348c.74.665 1.194 1.556 1.194 2.53v.53c0 .353.53.353.53 0v-.53c0-1.12-.504-2.126-1.318-2.878z"
                        opacity={1}
                        data-original="#c4dcf0"
                    />
                    <path
                        fill="#ff7f29"
                        d="m4.538 2.327-.5.427c.85.17 1.6.548 2.177 1.064l.405-.347a5.07 5.07 0 0 0-2.082-1.144z"
                        opacity={1}
                        data-original="#ff7f29"
                        className=""
                    />
                    <path
                        fill="#549ad4"
                        d="M2.119 1.32c.236 0 .354.288.185.454l-.348.348h1.337c2.693 0 4.91 1.87 4.91 4.228v.529c0 .353-.53.353-.53 0v-.53c0-2.022-1.944-3.698-4.38-3.698H1.967l.337.338c.27.25-.126.644-.374.373l-.794-.793a.265.265 0 0 1 0-.376l.794-.792a.264.264 0 0 1 .189-.08z"
                        opacity={1}
                        data-original="#549ad4"
                    />
                </g>
            </svg>

        </>
    )
}

export default SeamlessIntegrationIcon